import { Skeleton, Stack } from '@mui/material';

export const FlyerCardSkeleton = ({
  showTag,
  hasCTA,
  showFavoriteButton,
}: {
  showTag: boolean;
  hasCTA: boolean;
  showFavoriteButton: boolean;
}) => (
  <Stack spacing={1}>
    <Skeleton
      variant="rounded"
      width="100%"
      height="100%"
      sx={{
        aspectRatio: '1/1.29',
        minHeight: 210,
        borderRadius: 2,
        flexGrow: 1,
      }}
    />
    <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
      <Stack flexGrow={1}>
        <Skeleton variant="text" width="90%" height={28} />
        <Skeleton variant="text" width="70%" height={28} />
      </Stack>

      {showFavoriteButton && <Skeleton variant="circular" width={28} height={28} />}
    </Stack>

    {showTag && <Skeleton variant="rounded" width="35%" height={24} sx={{ borderRadius: 3 }} />}
    {hasCTA && <Skeleton variant="rounded" height={32} sx={{ borderRadius: 2 }} />}
  </Stack>
);
